// extracted by mini-css-extract-plugin
module.exports = {"hidden":"service-list_hidden__f9EtQ","services":"service-list_services__VEQ61"};